<template>
  <nav class="container p-20 border-b border-light-gray">
    <h2 class="text-22 font-bold mb-24">{{ name }}</h2>
    <ul class="text-14 leading-1.2 column-2 lg:column-4 mb-24">
      <li v-for="item in items" class="mb-12">
        <a :href="item.value" class="link link-supporting">
          <h3>{{ item.name }}</h3>
        </a>
      </li>
    </ul>
    <div v-if="! viewMore" class="lg:hidden text-center">
      <button class="text-14 link link-supporting" @click="viewMore = true">View More</button>
    </div>
  </nav>
</template>
<script>
export default {
  data () {
    return {
      ...jsonFromPage('#data-footer-menu'),
      viewMore: false,
    }
  },

  computed: {
    items () {
      return this.menuItems.filter(i => i.enabled).slice(0, (this.$mq.lg || this.viewMore) ? undefined : 8)
    }
  }
}
</script>
